import React from "react";

const PilotBadge = () => (
  <span
    className="badge badge-warning ml-1"
    style={{ fontSize: "0.6rem", verticalAlign: "middle" }}
  >
    Pilot
  </span>
);

export default PilotBadge;
